import { createActionGroup, props } from '@ngrx/store';
import { ProductManager } from '@shared/interfaces/product-manager/product-manager.interface';

export const productManager = createActionGroup({
  source: '[ PRODUCT MANAGER ]',
  events: {
    load: props<{ searchInput?: string }>(),
    create: props<{ productManager: Omit<ProductManager, 'id'> }>(),
    update: props<{ productManager: ProductManager }>(),
    'save success': props<{ context: string }>(),
    'save failure': props<{ context: string }>(),
    'load success': props<{ productManagers: Array<ProductManager> }>(),
    delete: props<{ id: number; searchInput: string; name: string }>()
  }
});
